import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Center } from "@pdfking/math"
import { TurnBox } from "@pdfking/renderer-api"

import type { ImpositionPage } from "#internal"

import { OwnBox } from "./OwnBox"

/** A box in the page's own frame — its origin the page's own corner — read on
 * the sheet, where the page stands turned; and, on a page seen from behind,
 * mirrored across the page's middle. */
export const OwnToSheet =
  (page: ImpositionPage) =>
  (box: SpatialRectangle<Distance>): SpatialRectangle<Distance> => {
    const own = OwnBox(page)
    const x = page.is_front ? box.x : ((own.width - box.x - box.width) as Distance)
    const placed = { ...box, x: (own.x + x) as Distance, y: (own.y + box.y) as Distance }
    if (!page.rotation) return placed
    return TurnBox(placed, page.rotation, Center(own))
  }
